/**
 * Utility functions for token estimation and tracking
 */

/**
 * Estimates tokens for a single text string
 * @param {string} text - The text to estimate tokens for
 * @returns {number} - Estimated token count
 */
export const estimateTokens = (text) => {
  if (!text) return 0;
  // GPT models use roughly 4 characters per token on average for English
  return Math.ceil(text.length / 4);
};

/**
 * Estimates tokens for an entire conversation history
 * @param {Array} conversationHistory - Array of conversation objects with query and response
 * @returns {number} - Total estimated token count
 */
export const estimateConversationTokens = (conversationHistory) => {
  let total = 0;

  conversationHistory.forEach(item => {
    // Count query tokens
    total += estimateTokens(item.query || '');

    // Count response tokens
    total += estimateTokens(item.response || '');
  });

  return total;
};